<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BkadD/tc-custom/9780765389329.jpg?1738254592828" alt="This image is the cover for the book Waste Tide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waste Tide
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A LOCUS AWARD FINALIST FOR BEST FIRST NOVEL</b><br/><br/><b>Award-winning author Chen Qiufan's <i>Waste Tide</i> is a thought-provoking vision of the future.<br/><br/> Translated by Ken Liu, who brought Cixin Liu's Hugo Award–winning <i>The Three Body Problem</i> to English-speaking readers.</b><br/><br/> Mimi is drowning in the world's trash.<br/><br/> She’s a waste worker on Silicon Isle, where electronics -- from cell phones and laptops to bots and bionic limbs — are sent to be recycled. These amass in towering heaps, polluting every spare inch of land. On this island off the coast of China, the fruits of capitalism and consumer culture come to a toxic end.<br/><br/> Mimi and thousands of migrant waste workers like her are lured to Silicon Isle with the promise of steady work and a better life. They're the lifeblood of the island’s economy, but are at the mercy of those in power.<br/><br/> A storm is brewing, between ruthless local gangs, warring for control. Ecoterrorists, set on toppling the status quo. American investors, hungry for profit. And a Chinese-American interpreter, searching for his roots.<br/><br/> As these forces collide, a war erupts -- between the rich and the poor; between tradition and modern ambition; between humanity’s past and its future.<br/><br/> Mimi, and others like her, must decide if they will remain pawns in this war or change the rules of the game altogether.<br/><br/><b>"An accomplished eco-techno-thriller with heart and soul as well as brain. </b><b>Chen Qiufan is an astute observer, both of the present world and of the future that the next generation is in danger of inheriting</b>." —<b>David Mitchell</b><b>, <i>New York Times–</i>bestselling author of </b><i><b>Cloud Atlas</b></i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chen Qiufan, Ken Liu
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b6b2f80